import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Container, Grid, Table } from "semantic-ui-react";
import { CREATE_PATTERN_RESET } from "../../actions/constants/pattern";
import { getAllPatterns } from "../../actions/patternActions";
import { Heading2 } from "../../components/value-cssmodules/TextComponent";
import { PatternData } from "../../types/siteTypes";
import {
  allPatternsSelector,
  userIsAdminSelector,
} from "../../utils/selectors";
import isEmpty from "../../validation/is-empty";
import styles from "./PatternListAdmin.module.scss";
import PatternListRow from "./PatternListRow";
import Spinner from "../../components/Spinner";
import CustomPagination from "../../components/Pagination/CustumPagination";
import { useSearchParams } from "react-router-dom";

const PatternListAdmin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { patterns, loading, pagination } = useSelector((state) => allPatternsSelector(state));
  const admin = useSelector((state) => userIsAdminSelector(state));
  const [page, setPage] = useState<number>(1)

  const [searchParams] = useSearchParams();
  const category = searchParams.get("category") || "";
  const client = searchParams.get("client") || "";

  useEffect(() => {
    dispatch({ type: CREATE_PATTERN_RESET });
    if (!admin) {
      navigate("/dashboard");
    }
  }, [dispatch, navigate, admin]);

  useEffect(() => {
    dispatch(getAllPatterns("", page, 12, { ucategory: category, client }));
  }, [dispatch, page, category, client]);

  if (loading) {
    return <Spinner />;
  }

  return (
    <Grid className={styles.self}>
      <Container>
        <Grid.Row>
          <Grid.Column width={8}>
            <Heading2>
              <FormattedMessage id="admin.patternList.title" />
            </Heading2>
          </Grid.Column>
        </Grid.Row>

        <Grid.Row>
          {" "}
          <Table striped size="small">
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>
                  <FormattedMessage id={"admin.list.titleId"} />
                </Table.HeaderCell>
                <Table.HeaderCell>
                  <FormattedMessage id={"admin.list.name"} />
                </Table.HeaderCell>
                <Table.HeaderCell>
                  <FormattedMessage id="cart.tableTitle.price" />
                </Table.HeaderCell>
                <Table.HeaderCell>
                  <FormattedMessage id={"categories.categories.title"} />
                </Table.HeaderCell>
                <Table.HeaderCell>
                  <FormattedMessage id={"admin.list.user"} />
                </Table.HeaderCell>

                <Table.HeaderCell></Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {!isEmpty(patterns) ? (
                patterns.map((pattern: PatternData) => (
                  <PatternListRow
                    pattern={pattern}
                    key={pattern._id}
                  />
                ))
              ) : (
                <Table.Row>
                  <Table.Cell colSpan={7} textAlign="center">
                    <FormattedMessage
                      id="admin.patternList.empty"
                      defaultMessage="No patterns found."
                    />
                  </Table.Cell>
                </Table.Row>
              )}
            </Table.Body>
          </Table>
        </Grid.Row>
        <CustomPagination
          page={page}
          totalPages={pagination?.totalPages}
          onPageChange={(p) => setPage(p)}
        />
      </Container>
    </Grid>
  );
};

export default PatternListAdmin;
